// Library
import { CarouselModule } from "ngx-owl-carousel-o";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NgxSpinnerModule } from "ngx-spinner";
import { FilterPipe } from "./pipes/filter-by.pipe";
import { GoogleMapComponent } from "./component/google-map/google-map.component";
import { QRCodeModule } from "angularx-qrcode";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NzProgressModule } from "ng-zorro-antd/progress";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { Select2Module } from "ng-select2-component";
import { ToastrModule } from "ngx-toastr";
import { NgOtpInputModule } from "ng-otp-input";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgxImageCompressService } from "ngx-image-compress";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { NgxPayPalModule } from "ngx-paypal";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
// Library

import { NgModule } from "@angular/core";

import { CommonModule, NgOptimizedImage } from "@angular/common";
import { AddProductCrousalComponent } from "../admin/sub-admin/add-product-crousal/add-product-crousal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NewDahsboardHeaderComponent } from "../admin/new-dahsboard-header/new-dahsboard-header.component";
import { NewDahsboardSidebarComponent } from "../admin/new-dahsboard-sidebar/new-dahsboard-sidebar.component";
import { AskComponent } from "../customers/marketplace/ask/ask.component";
import { AskCarsouelComponent } from "../customers/marketplace/ask-carsouel/ask-carsouel.component";
import { AskForumComponent } from "../customers/marketplace/ask/ask-forum/ask-forum.component";
import { MarketplaceForumComponent } from "../customers/marketplace/marketplace-forum/marketplace-forum.component";
import { MarketplaceRecommendationComponent } from "../customers/marketplace/recommendation/recommendation.component";
import { ArticlesComponent } from "../customers/community/articles/articles.component";
import { ArticlesCarsouelComponent } from "../customers/community/articles-carsouel/articles-carsouel.component";
import { MarketplaceBottomBannerComponent } from "../customers/marketplace/bottom-banner/marketplace-bottom-banner.component";
import { MemberShopAdsComponent } from "../admin/admin-market-blog/member-shop-ads/member-shop-ads.component";
import { MemberBannerComponent } from "../admin/admin-market-blog/member-banner/member-banner.component";
import { AddProductCrouselCustComponent } from "../customers/add-product-crousel-cust/add-product-crousel-cust.component";
import { EditorComponent } from "../customers/editor/editor.component";
import { ManageEventsComponent } from "../customers/community/events/manage-events/manage-events.component";
import { MyCarouselSwiperComponent } from "../shareModule/component/my-carousel-swiper/my-carousel-swiper.component";
import { MultiDropdownComponent } from "../shareModule/component/multi-dropdown/multi-dropdown.component";
import { CustomerFooterComponent } from "../customers/customer-footer/customer-footer.component";
import { HomeFooterComponent } from "../admin/auth/home-footer/home-footer.component";
import { ProductTemplateComponent } from "../admin/admin-market/product-template/product-template.component";
import { SubadminHeaderComponent } from "../admin/sub-admin/subadmin-header/subadmin-header.component";
import { HomeBottomBannerComponent } from "../admin/auth/home-bottom-banner/home-bottom-banner.component";
import { AddProductComponent } from "../admin/sub-admin/add-product/add-product.component";
import { MemberNewsComponent } from "../admin/admin-market-blog/member-news/member-news.component";
import { ManageCategoryComponent } from "../admin/admin-market/manage-category/manage-category.component";
import { MemberBulletinComponent } from "../admin/admin-market-blog/member-bulletin/member-bulletin.component";
import { SignInModalComponent } from "../admin/auth/sign-in-modal/sign-in-modal.component";
import { SignUpModalComponent } from "../admin/auth/sign-up-modal/sign-up-modal.component";
import { HomeHeaderComponent } from "../admin/auth/home-header/home-header.component";
import { FeedbacksCardComponent } from "../admin/auth/feedbacks-card/feedbacks-card.component";

import { RouterModule } from "@angular/router";

// Pipe
import { CustomPipePipe } from "../shareModule/pipes/custom-pipe.pipe";
import { InventoryPipePipe } from "../shareModule/pipes/inventory-pipe.pipe";
import { PipetypePipe } from "../shareModule/pipes/pipetype.pipe";
import { AddPhoneSearchPipe } from "../shareModule/pipes/add-phone-search.pipe";
import { ReferralRewardPipePipe } from "../shareModule/pipes/referral-reward-pipe.pipe";
import { AddDeductPipePipe } from "../shareModule/pipes/add-deduct-pipe.pipe";
import { ClosingListingPipePipe } from "../shareModule/pipes/closing-listing-pipe.pipe";
import { NewSubadminPipe } from "../shareModule/pipes/new-subadmin.pipe";
import { TruncatePipe } from "../shareModule/pipes/truncate.pipe";
import { NullCheckPipe } from "../shareModule/pipes/null-check.pipe";
import { AppStateModule } from "./states/app-state.module";
import { ProductSectionComponent } from "../admin/admin-market/member-email-template/custom-email-tags/add-product-section/add-product-section.component";
import { EmailFooterComponent } from "../admin/admin-market/member-email-template/custom-email-tags/email-footer/email-footer.component";
import { MemberEmailTemplateComponent } from "../admin/admin-market/member-email-template/member-email-template.component";
import { CommonProductCardViewComponent } from "../customers/common/common-product-card-view/common-product-card-view.component";
import { CommonProductCardViewLoaderComponent } from '../customers/common/common-product-card-view-loader/common-product-card-view-loader.component';
import { HtmlToPngService } from "./services/html-to-png.service";
import { EmailBannerComponent } from "../admin/admin-market/member-email-template/custom-email-tags/email-banner/email-banner.component";
import { EmailLogoComponent } from "../admin/admin-market/member-email-template/custom-email-tags/email-logo/email-logo.component";
import { IconSelectorComponent } from "../customers/community/icon-selector/icon-selector.component";
import { CroppedImageComponent } from "../customers/cropped-image/cropped-image.component";
import { CropImageComponent } from "./component/crop-image/crop-image.component";

@NgModule({
  declarations: [
    AddProductCrouselCustComponent,
    // MemberShopComponent,
    FeedbacksCardComponent,
    AddProductCrousalComponent,
    NewDahsboardHeaderComponent,
    NewDahsboardSidebarComponent,
    FilterPipe,
    GoogleMapComponent,
    AskComponent,
    AskCarsouelComponent,
    AskForumComponent,
    MarketplaceForumComponent,
    MarketplaceRecommendationComponent,
    ArticlesComponent,
    ArticlesCarsouelComponent,
    MarketplaceBottomBannerComponent,
    MemberShopAdsComponent,
    MemberBannerComponent,
    EditorComponent,
    ManageEventsComponent,
    MyCarouselSwiperComponent,
    MultiDropdownComponent,
    CustomerFooterComponent,
    CustomPipePipe,
    InventoryPipePipe,
    HomeFooterComponent,
    ProductTemplateComponent,
    SubadminHeaderComponent,
    HomeBottomBannerComponent,
    AddProductComponent,
    IconSelectorComponent,
    MemberNewsComponent,
    ManageCategoryComponent,
    MemberBulletinComponent,
    SignInModalComponent,
    SignUpModalComponent,
    HomeHeaderComponent,
    PipetypePipe,
    AddPhoneSearchPipe,
    ReferralRewardPipePipe,
    AddDeductPipePipe,
    ClosingListingPipePipe,
    NewSubadminPipe,
    TruncatePipe,
    NullCheckPipe,
    MemberEmailTemplateComponent,
    ProductSectionComponent,
    EmailFooterComponent,
    CommonProductCardViewComponent,
    CommonProductCardViewLoaderComponent,
    EmailLogoComponent,
    EmailBannerComponent,
    CroppedImageComponent,
  ],
  imports: [
    NgOptimizedImage,
    CropImageComponent,
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NzTabsModule,
    CarouselModule,
    NgxSpinnerModule,
    CKEditorModule,
    QRCodeModule,
    NzProgressModule,
    NgbModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    Select2Module,
    ToastrModule.forRoot({
      timeOut: 1000, // 1 second
      positionClass: "toast-top-right", // example position
      preventDuplicates: true,
    }),
    CarouselModule,
    NgbTimepickerModule,
    DragDropModule,
    NgxIntlTelInputModule,
    NgxPayPalModule,
    NgOtpInputModule,
    NgxSliderModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NzTabsModule,
    AppStateModule,
  ],
  exports: [
    CommonModule,
    NgOptimizedImage,
    AddProductCrouselCustComponent,
    NgbModule,
    AddProductCrousalComponent,
    NewDahsboardHeaderComponent,
    NewDahsboardSidebarComponent,
    IconSelectorComponent,
    NzTabsModule,
    CarouselModule,
    NgxSpinnerModule,
    FilterPipe,
    AskComponent,
    AskCarsouelComponent,
    ArticlesComponent,
    ArticlesCarsouelComponent,
    MarketplaceBottomBannerComponent,
    MemberShopAdsComponent,
    MemberBannerComponent,
    EditorComponent,
    ManageEventsComponent,
    MyCarouselSwiperComponent,
    QRCodeModule,
    MultiDropdownComponent,
    CommonModule,
    CustomerFooterComponent,
    NgbModule,
    NzProgressModule,
    CustomPipePipe,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    InventoryPipePipe,
    CKEditorModule,
    Select2Module,
    HomeFooterComponent,
    ProductTemplateComponent,
    SubadminHeaderComponent,
    HomeBottomBannerComponent,
    RouterModule,
    AddProductComponent,
    MemberNewsComponent,
    ManageCategoryComponent,
    MemberBulletinComponent,
    ToastrModule,
    SignInModalComponent,
    SignUpModalComponent,
    HomeHeaderComponent,
    PipetypePipe,
    AddPhoneSearchPipe,
    ReferralRewardPipePipe,
    AddDeductPipePipe,
    ClosingListingPipePipe,
    NewSubadminPipe,
    CarouselModule,
    NgbTimepickerModule,
    DragDropModule,
    NgxIntlTelInputModule,
    NgxPayPalModule,
    NgOtpInputModule,
    NgxSliderModule,
    CalendarModule,
    TruncatePipe,
    FeedbacksCardComponent,
    MarketplaceForumComponent,
    MarketplaceRecommendationComponent,
    AppStateModule,
    NullCheckPipe,
    MemberEmailTemplateComponent,
    ProductSectionComponent,
    EmailFooterComponent,
    CommonProductCardViewComponent,
    CommonProductCardViewLoaderComponent,
    EmailLogoComponent,
    EmailBannerComponent,
    CroppedImageComponent,
    CropImageComponent,
  ],
  providers: [HtmlToPngService]
})
export class ShareModule { }
